import type { PopperPlacementType } from "@mui/material";

import { ClickAwayListener, Paper, Popper } from "@mui/material";

import ApplicationsMenu from "~/components/worksuite/ApplicationsMenu";

interface ApplicationsMenuPopperProps {
	anchorEl: HTMLElement | null;
	onClose: () => void;
	placement: PopperPlacementType;
}

const ApplicationsMenuPopper = ({ anchorEl, onClose, placement }: ApplicationsMenuPopperProps) => (
	<Popper
		anchorEl={anchorEl}
		open={Boolean(anchorEl)}
		placement={placement}
		sx={{ zIndex: (theme) => theme.zIndex.modal }}
	>
		<ClickAwayListener onClickAway={onClose}>
			<Paper
				onClick={onClose}
				sx={{
					maxHeight: "calc(100vh - 96px)",
					maxWidth: 440,
					overflowY: "auto",
					p: 1.5,
					width: "calc(100vw - 32px)"
				}}
				variant="outlined"
			>
				<ApplicationsMenu />
			</Paper>
		</ClickAwayListener>
	</Popper>
);

export default ApplicationsMenuPopper;
